<template>
  <slot>
    <h1 class="govuk-heading-xl govuk-page-title">{{ formTitle }}</h1>

    <div class="govuk-template__body">
      <div class="govuk-form-group govuk-wizard" id="main-content">
        <div class="content">
          <error-bag></error-bag>
          <div class="govuk-accordion js-enabled" :aria-expanded="false" data-module="idsk-accordion">
            <recursive-component :structure="treeStructure" identifier="form" :level="level"></recursive-component>
          </div>
        </div>
      </div>
    </div>
  </slot>
</template>
<script lang="ts" src="@/library/builder/FormBuilder.ts"></script>
